import '@fontsource/poppins/latin-400.css';
import '@fontsource/poppins/latin-500.css';
import '@fontsource/poppins/latin-600.css';
import '@fontsource/poppins/latin-700.css';
import './platform/styles/tokens.css';
import './platform/styles/base.css';
import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { installGlobalErrorHandlers } from './platform/shell/CrashBanner';

// The gym's coverage map (?coverage): a developer's page in a chunk of its own, never loaded by the totem.
const CoverageView = lazy(() => import('./platform/coverage/CoverageView'));

installGlobalErrorHandlers();

const root = document.getElementById('root');
if (!root) throw new Error('index.html has no #root');
const coverage = new URLSearchParams(window.location.search).has('coverage');
createRoot(root).render(
  <StrictMode>
    {coverage ? <Suspense fallback={null}><CoverageView /></Suspense> : <App />}
  </StrictMode>,
);
